const COMMON_PATH = {
  UN_AUTHORIZATION: "/un-authorization-page",
  FORBIDDEN: "/forbidden-page",
};

const CUSTOMER_PATH = {};

const MANAGER_PATH = {
  MANAGE: "/",
  DASHBOARD: "/dashboard",
  LICENSE_REGISTRATION: {
    LIST: "/license-registration-list",
    ADD: "/license-registration-list/add-license",
    EDIT: "/license-registration-list/edit-license",
    DETAIL: "/license-registration-list/detail-license",
  },
  LICENSE_MANAGEMENT: {
    LIST: "/license-management-list",
    ADD: "/license-management-list/add-license",
    EDIT: "/license-management-list/edit-license",
  },
  AUTH: {
    SIGN_IN: "/sign-in",
    FORGOT_PASSWORD: "/forgot-password",
  },
  USER: {
    LIST: "/user-list",
    ADD: "/user-list/add-user",
    EDIT: "/user-list/edit-user",
  },
  PRODUCT: {
    LIST: "/product-list",
    ADD: "/product-list/add-product",
    EDIT: "/product-list/edit-product",
  },
  CUSTOMER: {
    REQUEST: "/customer-requests",
  },
  CONTACT: {
    LIST: "/customer-inquiries",
  },
  CONVERSION_RECORD: {
    LIST: "/transcoder",
  },
};

export { COMMON_PATH, CUSTOMER_PATH, MANAGER_PATH };
